import React from 'react';

import TextField from '../../../../forms/TextField';
import Link from '../Link';

interface UrlProps {
  upload?: boolean;
}

export default function Url({ upload = false }: UrlProps) {
  if (upload) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link fieldName="momentNativeAd.url" optional />
    );
  }

  return <TextField name="momentNativeAd.url" label="Url" />;
}
